import { gql } from "@apollo/client";

export const ContributionNodeFragment = gql`
  fragment ContributionNode_contribution on Contribution {
    id
    authorName
    text
  }
`;
